import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';

/**
 * 프로모션 배너 컴포넌트
 * @returns JSX.Element
 */
const PromotionBanner = () => {
	return (
		<section className="main-promotion">
			<div className="main-promotion-inner">
				<Link to={NAV_PATH.PROMOTION} className="main-promotion-btn btn sm black">
					자세히보기
				</Link>
			</div>
		</section>
	);
};
export default PromotionBanner;
